<div class="isg-page-layout">

  <div class="isgtopbar" *ngIf="showTopbar">
    <app-topbar (toggleMenu)="toggleMenu()"
                (impersonateChanged)="onImpersonateChanged($event)"></app-topbar>
  </div>

  <div class="isgmainpanel">

    <div class="isgmenupanel" *ngIf="showMenubar&&!menuHidden">
      <app-menu-vertical #lhsMenu></app-menu-vertical>
    </div>

    <div class="isgrhs-menu">
    </div>

    <div class="isgrhs">
      <div kendoDialogContainer></div>
      <div class="isgcontent">
        <router-outlet></router-outlet>
      </div>

    </div>

  </div>

  <div class="isgfooter" *ngIf="showFooter">
    <app-footer></app-footer>
  </div>

</div>

<ng-template #idleContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">You will be signed out due to inactivity.</h4>

  </div>
  <div class="modal-body">
    <p>Time Remaining: {{idleCountdown}} seconds</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close('logout')">Logout</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
  </div>
</ng-template>
